// The right-hand dock that holds a workspace chat (Lane 1355, moved from the sourcing
// event workspace). The round Wingman bubble (ChatBubble.js) opens it; on the sourcing
// event and deck pages the bubble sits in its own strip while the chat is closed
// (ChatRail.js, Lane 1387). The "Chat" tab that used to reopen it was replaced by the
// bubble in Lane 1362.
import React from 'react';
import { CHAT_WIDTH } from './useDockedChat';
import '../../pages/ListLinear.css';     // the palette tokens (declared on .ll and .wchat)
import './workspaceChat.css';

// Kept mounted while hidden, so the thread (and a reply still coming) survive.
// `id`: what the bubble's aria-controls names.
export function ChatDock({ dock, id, children }) {
  return (
    <div id={id} className="wchat wchat-dock" hidden={!dock.open} style={{ width: dock.width }}>
      <div className="wchat-drag" role="separator" aria-orientation="vertical" tabIndex={0}
        aria-label="Chat width: drag, or use the arrow keys" aria-valuenow={dock.width}
        aria-valuemin={CHAT_WIDTH.min} aria-valuemax={CHAT_WIDTH.max}
        onPointerDown={dock.startDrag} onKeyDown={dock.nudge} />
      {children}
    </div>
  );
}
